module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-block-inner step-one"
  }, [_c('span', {
    staticClass: "product-block-span step-one-top-margin"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.subtitle)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-commerce-logos"
  }, _vm._l((_vm.commerceLogos), function(logo, index) {
    return _c('span', {
      class: ("social-logo " + logo + "-social-logo " + (_vm.logoClass(index)))
    }, [_c('img', {
      attrs: {
        "src": _vm.getSocialImageUrl(logo)
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "hero-social-logos"
  }, _vm._l((_vm.socialLogos), function(logo, index) {
    return _c('span', {
      class: ("social-logo " + logo + "-social-logo " + (_vm.logoClass(index)))
    }, [_c('img', {
      attrs: {
        "src": _vm.getSocialImageUrl(logo)
      }
    })])
  }), 0), _vm._v(" "), _c('DemoButton', {
    attrs: {
      "buttonMessage": 'Software, Use Attach'
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "product-block-span step-one-images animated"
  }, [_c('img', {
    staticClass: "phone-image player-attach-content",
    attrs: {
      "src": require("../../../../assets/winter-2019/hero-phone-16.png")
    }
  }), _vm._v(" "), _c('video', {
    staticClass: "phone-image-inner",
    attrs: {
      "src": "https://s3.amazonaws.com/attach-videos/XMpqlCjT82Cgip0hnQF1_attach_anywhere_sm.mov",
      "muted": "",
      "playsinline": "",
      "autoplay": "",
      "loop": ""
    },
    domProps: {
      "muted": true
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "macbook-image player-attach-content",
    attrs: {
      "src": require("../../../../assets/winter-2019/hero-macbook-1.png")
    }
  }), _vm._v(" "), _c('video', {
    staticClass: "macbook-image-inner",
    attrs: {
      "src": "https://attach-videos.s3.amazonaws.com/eWkquuN0R1K6Y5BYB2JA_attach_anywhere_desktopV3.mp4",
      "muted": "",
      "playsinline": "",
      "autoplay": "",
      "loop": ""
    },
    domProps: {
      "muted": true
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c96e242"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/site/MikMakAttach/components/StepUseAttachAnywhere.vue
// module id = 453
// module chunks = 0